<script setup lang="ts">
import type { TpgChangeEvent } from '@tpg/grammar-web';
import type { Slot } from 'vue';

export interface GrammarNavigationRailProps {
  selectedValue?: string;
}

interface GrammarNavigationRailSlots {
  default?: Slot;
}

const props = withDefaults(defineProps<GrammarNavigationRailProps>(), {
  selectedValue: '',
});

const emit = defineEmits<{
  change: [event: TpgChangeEvent<string>];
}>();

defineSlots<GrammarNavigationRailSlots>();

function onChange(event: TpgChangeEvent<string>) {
  emit('change', event);
}
</script>

<template>
  <tpg-navigation-rail v-bind="props" @tpg-change="onChange">
    <slot />
  </tpg-navigation-rail>
</template>
